import { EventType, getEventTypeName } from "../events/event-type";
import { WebEvent, getWebEvents } from "../events/web-event";

function buildCalendarCard(event: WebEvent): HTMLDivElement {
  const div = document.createElement("div");
  div.classList.add("calendar-event-card");
  div.classList.add(event.type.split("_").join("-"));
  div.innerHTML = `
    <h4>${getEventTypeName(event.type)}</h4>
    <h5>${[event.topic, event.presenter].filter(Boolean).join(" with ")}</h5>
    <p>${event.description || ""}</p>
    <div class="calendar-event-card-location">Location: ${event.location}</div>
    ${event.link ? `<a href="${event.link}">${event.linkText || "More info"}</a>` : ""}
  `;

  return div;
}

function buildCalendarCardList(events: WebEvent[]): HTMLDivElement[] {
  return events.map(buildCalendarCard);
}

function extractUniqueDates(events: WebEvent[]): Date[] {
  const dateStrings = events.map((event) => event.startTime.toDateString());
  const uniqueDatesSet: Set<string> = new Set(dateStrings);
  return Array.from(uniqueDatesSet).map((dateStr) => new Date(dateStr));
}

function extractEventsOnDate(events: WebEvent[], date: Date): WebEvent[] {
  return events.filter(
    (event) =>
      event.startTime.getFullYear() === date.getFullYear() &&
      event.startTime.getMonth() === date.getMonth() &&
      event.startTime.getDate() === date.getDate(),
  );
}

export function fillCalendar(selector: string): void {
  getWebEvents().then((events) => {
    if (events === null) {
      fillErrorCalendar(selector);
      return;
    }
    if (events.length === 0) {
      fillEmptyCalendar(selector);
      return;
    }

    const container = document.querySelector<HTMLElement>(selector);
    if (!container) return;

    container.innerHTML = "";

    const uniqueDates = extractUniqueDates(events).sort(
      (a, b) => a.getTime() - b.getTime(),
    );

    uniqueDates.forEach((date) => {
      const dateHeader = document.createElement("h3");
      dateHeader.innerText = date.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
      container.appendChild(dateHeader);

      const eventsOnDate = extractEventsOnDate(events, date);
      const eventsList = buildCalendarCardList(eventsOnDate);
      eventsList.forEach((eventListItem) => {
        container.appendChild(eventListItem);
      });
    });
  });
}

function fillEmptyCalendar(selector: string): void {
  const container = document.querySelector<HTMLElement>(selector);
  if (!container) return;

  container.innerHTML = "<p>No upcoming events.</p>";
}

function fillErrorCalendar(selector: string): void {
  const container = document.querySelector<HTMLElement>(selector);
  if (!container) return;

  container.innerHTML = "<p>Failed to load events. Try again later.</p>";
}
